import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger } from "./ui/sheet";
import { navLinks, profile } from "../mock/mock";
import { Link } from "react-router-dom";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-ivory-50/85 backdrop-blur-md border-b border-ink/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group">
          <div className="h-9 w-9 rounded-sm bg-ink text-ivory-50 grid place-items-center font-serif-display text-sm tracking-wider">
            {profile.initials}
          </div>
          <div className="leading-tight">
            <div className="font-serif-display text-[15px] text-ink">{profile.name}</div>
            <div className="text-[11px] uppercase tracking-[0.18em] text-ink/60">
              Executive Leadership · GCC
            </div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-6 xl:gap-7">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-[13px] text-ink/75 hover:text-ink link-underline transition-colors whitespace-nowrap"
            >
              {l.label}
            </a>
          ))}
          <a
            href={`mailto:${profile.email}`}
            className="text-[13px] px-4 py-2 rounded-sm bg-ink text-ivory-50 hover:bg-ink-700 transition-colors whitespace-nowrap"
          >
            Get in touch
          </a>
        </nav>

        <div className="lg:hidden">
          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <button
                aria-label="Open menu"
                className="h-10 w-10 grid place-items-center rounded-sm border border-ink/15 text-ink hover:bg-ink hover:text-ivory-50 transition-colors"
              >
                <Menu className="h-5 w-5" />
              </button>
            </SheetTrigger>
            <SheetContent side="right" className="bg-ivory-50 border-l border-ink/10 w-[80%]">
              <div className="flex items-center justify-between mb-8">
                <div className="font-serif-display text-xl text-ink">{profile.name}</div>
                <button onClick={() => setOpen(false)} aria-label="Close" className="h-9 w-9 grid place-items-center">
                  <X className="h-5 w-5" />
                </button>
              </div>
              <nav className="flex flex-col gap-5">
                {navLinks.map((l) => (
                  <a
                    key={l.href}
                    href={l.href}
                    onClick={() => setOpen(false)}
                    className="font-serif-display text-2xl text-ink hover:text-bronze transition-colors"
                  >
                    {l.label}
                  </a>
                ))}
                <a
                  href={`mailto:${profile.email}`}
                  onClick={() => setOpen(false)}
                  className="mt-4 text-sm px-4 py-3 rounded-sm bg-ink text-ivory-50 text-center"
                >
                  Get in touch
                </a>
              </nav>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};

export default Header;
